import React from 'react';
import { Section } from '@carbon/react';
import { useTheme } from '../contexts/ThemeContext';
import PageContainer from '../components/PageContainer';
import ResidentsTable from '../components/ResidentsTable';

const InactiveResidents = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'g100';

  return (
    <PageContainer>
      <Section style={{
        padding: 0,
        maxWidth: '100%',
        margin: 0,
        height: '100%'
      }}>
        {/* Residents Table Component - inactive only */}
        <div style={{
          padding: 0,
          height: '100%'
        }}>
          <ResidentsTable inactiveOnly />
        </div>
      </Section>
    </PageContainer>
  );
};

export default InactiveResidents;
